import type { TemplateId } from "@lifescapsule/contracts";
import type { ImgHTMLAttributes, ReactNode } from "react";
import { CanonicalAssetImage } from "../../shared/CanonicalAsset";
import { catalogFixtureByTemplate } from "./catalogFixtureData";

export function CatalogFixture({
  templateId,
  fallback,
  className,
  loading = "lazy",
  fetchPriority = "auto",
}: {
  templateId: TemplateId;
  fallback: ReactNode;
  className?: string;
  loading?: ImgHTMLAttributes<HTMLImageElement>["loading"];
  fetchPriority?: ImgHTMLAttributes<HTMLImageElement>["fetchPriority"];
}) {
  const fixture = catalogFixtureByTemplate[templateId];
  if (!fixture) return fallback;

  return (
    <CanonicalAssetImage
      id={fixture.asset}
      alt={`Fictional ${fixture.label} sample book`}
      className={className}
      loading={loading}
      fetchPriority={fetchPriority}
      fallback={fallback}
    />
  );
}
